import React from 'react'
import { useLocation } from 'react-router-dom';
import { SiTicktick } from "react-icons/si";

export default function SuccessPage() {
    const { state: successMessage } = useLocation()
    return (
        <div className='landingPage'>
            <div className='successMessagePart'>
                <div className="successIcon">
                    <SiTicktick />
                </div>
                <p className='thankText'>
                    Thank you for the process.
                </p>
                <h3 className='successText'>
                    {successMessage}
                </h3>
            </div>
        </div>
    )
}